import { m } from '~/paraglide/messages'

// Explicit per-id map keeps `m.tree_type_*_title` accesses static so the
// bundler can tree-shake unused locale strings. A dynamic `m[`tree_type_${id}`]`
// lookup would force the whole `m` namespace into the bundle.
const treeNameMessages: Record<number, () => string> = {
  113: m.tree_type_113_title,
  115: m.tree_type_115_title,
  117: m.tree_type_117_title,
  118: m.tree_type_118_title,
  124: m.tree_type_124_title,
  125: m.tree_type_125_title,
  126: m.tree_type_126_title,
  130: m.tree_type_130_title,
  131: m.tree_type_131_title,
  135: m.tree_type_135_title,
  138: m.tree_type_138_title,
  140: m.tree_type_140_title,
  143: m.tree_type_143_title,
  147: m.tree_type_147_title,
  148: m.tree_type_148_title,
  164: m.tree_type_164_title,
  165: m.tree_type_165_title,
  166: m.tree_type_166_title,
  167: m.tree_type_167_title,
  168: m.tree_type_168_title,
  169: m.tree_type_169_title,
  170: m.tree_type_170_title,
  171: m.tree_type_171_title,
  172: m.tree_type_172_title,
  173: m.tree_type_173_title,
  174: m.tree_type_174_title,
}

export function useLocalizedTreeName(treeTypeId: () => number): () => string {
  return () => {
    const id = treeTypeId()
    const message = treeNameMessages[id]
    return message ? message() : `tree_type_${id}_title`
  }
}
